
import './App.css';
import Dictionary from "./Dictionary";

export default function App() {
  return (
    <div className="container">
      <div className="App">
  
        <Dictionary />
        <footer>
          <a href="https://github.com/StefanieBaeuchler/dictionary-react">
            Open source code</a>{" "}
          by Stefanie Bäuchler
        </footer>
      </div>
    </div>
  );
}


